<template>
  <div class="bar-separator" ref="bSep">
    <div class="title">
      {{line.title}}
    </div>
    <div class="values">
      <div class="bars">
        <div
            v-for="bar in line.bars"
            :style="{width: `${bar.value}%`, backgroundColor: bar.color}"
            class="bar"
        ></div>
      </div>
      <div class="percents">
        <div
            v-for="bar in cBars"
            :style="{width: bar.width}"
            class="percent"
        >{{ `${bar.value}%` }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";

const props = defineProps({
  line: Object,
})

const bSep = ref(null);

const cBars = computed(() => {
  const widths = props.line.bars.map(bar => bar.value);

  const minWidth = 5;

  const fixSizes = () => {
    for (let i = 0; i < widths.length; i++) {
      if (widths[i] < minWidth) {
        let deficit = minWidth - widths[i];
        widths[i] = minWidth;

        // Попробуем забрать у следующего элемента
        if (i < widths.length - 1 && widths[i + 1] > minWidth) {
          widths[i + 1] -= deficit;
        }
        // Если следующий элемент не может дать, попробуем у предыдущего
        else if (i > 0 && widths[i - 1] > minWidth) {
          widths[i - 1] -= deficit;
        }
      }
    }
  };

  fixSizes();

  return props.line.bars.map((bar, idx) => {
    return {
      ...bar,
      width: `${widths[idx]}%`
    }
  })
})


</script>

<style src="./BarSeparator.scss" lang="scss" />
